const TOTP_ENABLED_KEYS = ["is_totp_enabled", "totp_enabled"];

const readBooleanFromRecord = (
  record: Record<string, unknown> | undefined,
  keys: string[],
): boolean | undefined => {
  if (!record) return undefined;

  for (const key of keys) {
    const value = record[key];
    if (typeof value === "boolean") {
      return value;
    }
  }

  return undefined;
};

export const readTotpEnabledFromRecord = (
  record: Record<string, unknown> | undefined,
): boolean | undefined =>
  readBooleanFromRecord(record, TOTP_ENABLED_KEYS);

/** Reads TOTP status from login/settings payloads (supports legacy `totp_enabled`). */
export const readTotpEnabledFromSources = (
  ...sources: Array<Record<string, unknown> | undefined>
): boolean => {
  for (const source of sources) {
    const direct = readTotpEnabledFromRecord(source);
    if (direct !== undefined) return direct;

    const user = source?.user as Record<string, unknown> | undefined;
    const fromUser = readTotpEnabledFromRecord(user);
    if (fromUser !== undefined) return fromUser;

    const settings = source?.settings as Record<string, unknown> | undefined;
    const fromSettings = readTotpEnabledFromRecord(settings);
    if (fromSettings !== undefined) return fromSettings;
  }

  return false;
};

export const isTotpAlreadyEnabledMessage = (message: string): boolean => {
  const lower = message.toLowerCase();
  return (
    lower.includes("totp is already enabled") ||
    lower.includes("already enabled") ||
    lower.includes("already set up") ||
    lower.includes("already configured")
  );
};
